module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAJzCAMAAAD5volYAAAAgVBMVEW/ywPCzhDi7I7DzxTF0BnG0h7J1CnAzAjH0yPBzQzn8aPa5W/h64no86nf6oXU31fj7ZPo8qbK1S3M2DjO2kDL1zTT3lLe6YDm8J/l75zb5nPW4V/V4FvZ5GrR3Evk7pbN2TzP20TY42bk75nK1jHX4mPQ20jd53rc53fS3U/d6H3V1lQHAAAAZUlEQVR4Xq3BhRGEUAxAQdz13N37L/AKIO8nzLDr1crescAb9RbexWfYOQaGlWOjXuPf4Fv4Ee5gqTzCG3wK9/AAW+eV8AtP8CW8wgW+wDle4od4hhPDzDw2jYxDtW+YG6cjT+gP6fUrsC05+8QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/extend-sch-bg.png
// module id = 527
// module chunks = 0